export default __webpack_public_path__ + "static/media/projects.bc0f8033.svg";